import { supabase } from "./supabaseClient";

export interface AgentKey {
  id: string;
  name: string;
  key_prefix: string | null;
  credit_balance: number;
  rate_limit_per_min: number;
  active: boolean;
  created_at: string;
  calls: number;
}

export interface AdminAgentAccount extends AgentKey {
  owner_email: string | null;
}

const SUPABASE_URL = (import.meta as any).env.VITE_SUPABASE_URL || 'https://gdjfeumtqpjbroxqbfqv.supabase.co';

// Endpoints an agent connects to (shown in the UI).
export const AGENT_API_URL = `${SUPABASE_URL}/functions/v1/agent-api`;
export const MCP_URL = `${SUPABASE_URL}/functions/v1/mcp`;

// Mint a key — returns the plaintext once (store it now, it can't be recovered).
export async function createAgentKey(name: string): Promise<{ id: string; name: string; api_key: string; key_prefix: string }> {
  const { data, error } = await supabase.rpc('create_agent_key', { p_name: name });
  if (error) throw error;
  return data;
}

export async function listAgentKeys(): Promise<AgentKey[]> {
  const { data, error } = await supabase.rpc('list_agent_keys');
  if (error) throw error;
  return (data || []) as AgentKey[];
}

export async function revokeAgentKey(id: string): Promise<void> {
  const { error } = await supabase.rpc('revoke_agent_key', { p_id: id });
  if (error) throw error;
}

// ── CTO admin ────────────────────────────────────────────────────────────────
export async function adminListAgentAccounts(): Promise<AdminAgentAccount[]> {
  const { data, error } = await supabase.rpc('admin_list_agent_accounts');
  if (error) throw error;
  return (data || []) as AdminAgentAccount[];
}

export async function adminGrantAgentCredits(agentId: string, amount: number): Promise<number> {
  const { data, error } = await supabase.rpc('admin_grant_agent_credits', { p_agent_id: agentId, p_amount: amount });
  if (error) throw error;
  return data?.balance ?? 0;
}
